<main class="file-overview" aria-labelledby="file-overview-heading">
  <h1 id="file-overview-heading" class="visually-hidden">Selected file overview</h1>

  @if (metadataLoading) {
    <mat-progress-bar mode="indeterminate" aria-label="Loading file metadata"></mat-progress-bar>
  }

  @if (metadata) {
    <section class="metadata-strip" aria-label="File metadata">
      <div class="metadata-item">
        <span class="metadata-label">Document type</span>
        <strong>{{ formatDocumentType(metadata.documentType) }}</strong>
      </div>
      <div class="metadata-item">
        <span class="metadata-label">Processing</span>
        <strong class="status-value">
          <mat-icon aria-hidden="true">{{ processingIcon(metadata.processingStatus) }}</mat-icon>
          {{ formatProcessingStatus(metadata.processingStatus) }}
        </strong>
      </div>
      <div class="metadata-item">
        <span class="metadata-label">Pages</span>
        <strong>{{ ingestedPageCount }} of {{ pageCount }} ingested</strong>
      </div>
      <div class="metadata-item">
        <span class="metadata-label">Size</span>
        <strong>{{ formatFileSize(metadata.fileSizeBytes) }}</strong>
      </div>
      @if (metadata.uploadDate) {
        <div class="metadata-item">
          <span class="metadata-label">Uploaded</span>
          <strong>{{ metadata.uploadDate | date: 'medium' }}</strong>
        </div>
      }
      @if (metadata.processedDate) {
        <div class="metadata-item">
          <span class="metadata-label">Last processed</span>
          <strong>{{ metadata.processedDate | date: 'medium' }}</strong>
        </div>
      }
    </section>
  } @else if (metadataError) {
    <div class="inline-state error-state" role="alert">
      <mat-icon>error_outline</mat-icon>
      <span>{{ metadataError }}</span>
    </div>
  }

  <div class="section-heading">
    <div>
      <p class="eyebrow">Executive summary</p>
      <h2>What this file contains and how much has been evaluated</h2>
    </div>
    <button mat-flat-button type="button" (click)="openCompliance()" [disabled]="!complianceEligible">
      Open Compliance
    </button>
  </div>

  @if (summaryLoading) {
    <div class="summary-loading" aria-live="polite">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <span>Loading persisted file evidence…</span>
    </div>
  }

  <div class="summary-sections">
    @for (section of sections; track section.heading) {
      <section class="summary-section" [attr.data-availability]="availabilityLabel(section.value).toLowerCase()">
        <div class="summary-title-row">
          <mat-icon aria-hidden="true">{{ section.icon }}</mat-icon>
          <h3>{{ section.heading }}</h3>
          <span class="availability">
            <mat-icon aria-hidden="true">{{ availabilityIcon(section.value) }}</mat-icon>
            {{ availabilityLabel(section.value) }}
          </span>
        </div>
        <p>{{ sectionText(section.value) }}</p>
        <p class="source-note">{{ coverageText(section.value) }}</p>
      </section>
    }
  </div>

  @if (summaryError) {
    <div class="inline-state warning-state" role="status">
      <mat-icon>warning_amber</mat-icon>
      <span>{{ summaryError }}</span>
      <button mat-button type="button" (click)="retrySummary()">Retry</button>
    </div>
  }

  @if (generatedDate(); as generated) {
    <p class="projection-note">Summary projection built {{ generated | date: 'medium' }}.</p>
  }

  @if (metadata?.processingStatus === ProcessingStatus.PROCESSING_STATUS_PROCESSING) {
    <div class="inline-state processing-state" role="status">
      <mat-icon>hourglass_top</mat-icon>
      <span>Results are still being prepared for this file.</span>
      <button mat-button type="button" (click)="openTasks()">View tasks</button>
    </div>
  }
</main>
